// hooks/useAllProducts.js
import { useState, useEffect } from 'react';
import {BASE_URL} from "../config";

export const useAllProducts = () => {
    const [allProducts, setAllProducts] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchAllProducts = async () => {
            // Check if we already have products in localStorage
            const cachedProducts = localStorage.getItem('allProducts');
            const cachedTimestamp = localStorage.getItem('allProductsTimestamp');
            const oneHour = 60 * 60 * 1000; // 1 hour in milliseconds

            if (cachedProducts && cachedTimestamp && (Date.now() - parseInt(cachedTimestamp)) < oneHour) {
                setAllProducts(JSON.parse(cachedProducts));
                return;
            }

            setLoading(true);
            try {
                // Use the correct API endpoint - adjust based on your routes
                const response = await fetch(`${BASE_URL}api/v1/products?all=true`);

                if (!response.ok) {
                    throw new Error(`Failed to fetch products: ${response.status} ${response.statusText}`);
                }

                const data = await response.json();

                // Check the actual response structure
                console.log('API Response:', data);

                // Handle different response formats
                const products = data.data || data;

                if (!Array.isArray(products)) {
                    throw new Error('Invalid response format: expected array of products');
                }

                // Store in state and localStorage
                setAllProducts(products);
                localStorage.setItem('allProducts', JSON.stringify(products));
                localStorage.setItem('allProductsTimestamp', Date.now().toString());

            } catch (err) {
                setError(err.message);
                console.error('Error fetching all products:', err);

                // Fallback to cached data if available, even if expired
                const cachedProducts = localStorage.getItem('allProducts');
                if (cachedProducts) {
                    setAllProducts(JSON.parse(cachedProducts));
                }
            } finally {
                setLoading(false);
            }
        };

        fetchAllProducts();
    }, []);

    return { allProducts, loading, error };
};